import axiosInstance from 'integration/api/axiosInstance';
import {
  AdminAppProfessionalResponseDto,
  CommonEntitiesListResponse,
  LoginAsDto,
  UserLoginResDto,
} from '@docbay/schemas';
import { fetchProfessionalsProps } from 'common/types/professionals';

/**
 * ProfessionalsAPI is a service that provides endpoints for interacting with professionals
 */
export const ProfessionalsAPI = {
  /**
   * Fetches professionals based on provided parameters
   * @param searchItem - The search string to filter professionals by
   * @param page - The current page number of the results
   * @param limit - The maximum number of professionals per page
   * @param userTypes - A list of user types to filter professionals by
   * @returns A promise that resolves with a list of professionals and pagination details
   */
  fetchProfessionals: ({
    searchItem,
    page,
    limit,
    userTypes,
  }: fetchProfessionalsProps) => {
    const params = {
      includeDeleted: 'false',
      ...(page ? { page } : {}),
      ...(limit ? { limit } : {}),
      ...(searchItem ? { search: searchItem } : {}),
      ...(userTypes ? { userTypes: userTypes } : {}),
    };

    return axiosInstance.get<
      CommonEntitiesListResponse<AdminAppProfessionalResponseDto>
    >('/saas/users-management/professionals', {
      params,
    });
  },

  /**
   * Logs in as a specified user
   * @param data - The login details of the user to log in as
   * @returns A promise that resolves with the user's login response
   */
  loginAsUser: (data: LoginAsDto) => {
    return axiosInstance.post<UserLoginResDto>('/saas/login-as', data);
  },
  deleteClinicOwner: (id: string) =>
    /**
     * Deletes a clinic owner by ID
     * @param id - The ID of the clinic owner to delete
     * @returns A promise that resolves when the deletion is successful
     */
    axiosInstance.delete(`/saas/users-management/clinic-profile/${id}`),
  deleteDoctor: (doctorId: string) =>
    /**
     * Deletes a doctor by ID
     * @param doctorId - The ID of the doctor to delete
     * @returns A promise that resolves when the deletion is successful
     */
    axiosInstance.delete(`/saas/users-management/doctor-profile/${doctorId}`),
  deleteAdmin: (adminId: string) =>
    /**
     * Deletes an admin by ID
     * @param adminId - The ID of the admin to delete
     * @returns A promise that resolves when the deletion is successful
     */
    axiosInstance.delete(`/saas/users-management/admin-profile/${adminId}`),
  deleteSecretary: (secretaryId: string) =>
    /**
     * Deletes a secretary by ID
     * @param secretaryId - The ID of the secretary to delete
     * @returns A promise that resolves when the deletion is successful
     */
    axiosInstance.delete(
      `/saas/users-management/secretary-profile/${secretaryId}`,
    ),
};
